import React, { useState, forwardRef } from "react";
import { barcode_icon, search_icon } from "../../../assets";
import { useTranslation } from "react-i18next";
import { detectWebDeviceType, isTablet } from "../../../utils";

const ProductSearchBar = forwardRef(({ onSearch, value, showBarcode, placeholder, onKeyDown }, ref) => {
  const { t, i18n } = useTranslation();
  const deviceType = detectWebDeviceType();

  const isRTL = i18n.language === "ar";

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        width: "100%",
      }}
    >
      {/* Search Icon */}
      <span
        style={{
          position: "absolute",
          insetBlock: 0,
          [isRTL ? "right" : "left"]: 10,
          ...(isRTL ? {} : { top: deviceType === "tablet" ? 0 : 0 }), // Only apply `top` if not Arabic
          display: "flex",
          alignItems: "center",
          padding: "8px",
        }}
      >
        <img src={search_icon} alt="search_icon" />
      </span>

      {/* Input Field */}
      <input
        ref={ref}
        {...(value !== undefined ? { value } : {})}
        onChange={onSearch}
        type="text"
        placeholder={placeholder}
        style={{
          padding: "8px",
          [isRTL ? "paddingRight" : "paddingLeft"]: "48px", // icon space
          borderRadius: "8px",
          border: "1px solid #ccc",
          width: "100%",
          outline: "none",
        }}
        onKeyDown={onKeyDown}
      />

      {/* Barcode Icon */}
      {showBarcode &&
        <span
          style={{
            position: "absolute",
            insetBlock: 0,
            [isRTL ? "left" : "right"]: 10,
            display: "flex",
            alignItems: "center",
            padding: "8px",
            height: "40px",
            width: "40px",
          }}
        >
          <img src={barcode_icon} alt="barcode_icon" />
        </span>
      }

    </div>
  );
});

export default ProductSearchBar;
